// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__KDI3c","title":"Images45_title__7dzwL","images":"Images45_images__32nxE"};